import Swiper from 'swiper';
import {Navigation, Thumbs, EffectFade} from 'swiper/modules';
import {getOptionsFromJsonString} from "./utilities/options";
import {init360Images} from "./init360Images";
import {isTouchDevice} from "./touchDevice";
import {updateYTPlaceholders, installClickBlockerForYT} from './youtubeConsent.js';
import {loadLazyImages} from './lazyImages';

Swiper.use([Navigation, Thumbs]);

/**
 * Slide images (except the first one) carry a data-src instead of a src so the
 * browser does not fetch every gallery image on page load. Load the active
 * slide and its direct neighbours whenever the active slide changes.
 */
function loadSlideImages(swiper) {
    // Work with indices: Swiper emits slideChange before it refreshes the
    // swiper-slide-prev/-next classes, so those would lag one step behind.
    const count = swiper.slides.length;
    if (!count) {
        return;
    }
    for (const offset of [-1, 0, 1]) {
        const slide = swiper.slides[(swiper.activeIndex + offset + count) % count];
        if (slide) {
            loadLazyImages(slide);
        }
    }
}

function buildItemcardMainSwiper(el, options = {}, swiperThumbs = false, initialized = () => {
}) {
    Swiper.use([EffectFade]);
    let swiperMainImages = new Swiper(el, {
        speed: options.eff_interval,
        loop: true,
        effect: 'fade',
        items: 1,
        allowTouchMove: isTouchDevice(),
        thumbs: {
            swiper: swiperThumbs
        },
        on: {
            init: function () {
                loadSlideImages(this);
                initialized();
                updateYTPlaceholders(this.el);
            },
            slideChange: function (){
                loadSlideImages(this);
                const activeSlide = this.slides[this.activeIndex];
                if(activeSlide){
                    init360Images(activeSlide.querySelectorAll('.js-load360'));
                }
                updateYTPlaceholders(this.el);
            }
        },
    });

    return swiperMainImages;
}

function buildItemcardThumbsSwiper(el, options = {}, swiperMain) {
    let btnPrev = document.createElement("div");
    btnPrev.classList.add('swiper-button-prev');
    btnPrev.innerHTML = "<i class='icon icon-angle-left'></i>";

    let btnNext = document.createElement("div");
    btnNext.classList.add('swiper-button-next');
    btnNext.innerHTML = "<i class='icon icon-angle-right'></i>";

    el.appendChild(btnPrev);
    el.appendChild(btnNext);

    let loopedSlides = options.slidesPerViewThumbs;
    let slidesPerViewThumbs = options.slidesPerViewThumbs;
    options.allowTouchMove = false;
    options.touchRatio = 0;

    if (window.innerWidth < GLOBALS.gridBreakpoints.sm) {
        options.allowTouchMove = true;
        options.touchRatio = 1;
        if(options.spaceBetweenThumbs > 10){
            options.spaceBetweenThumbs = 10;
        }
    }

    if (window.innerWidth > options.directionBreakpoint) {
        if (options.directionThumbs === "vertical") {
            el.style.height = swiperMain.clientHeight + "px";
        } else {
            slidesPerViewThumbs = "auto";
        }
    } else {
        slidesPerViewThumbs = "auto";
        loopedSlides = 1;
    }

    let swiperThumbsImages = new Swiper(el, {
        speed: options.eff_interval,
        direction: getDirection(),
        slidesPerView: slidesPerViewThumbs,
        loopedSlides: loopedSlides,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        allowTouchMove: options.allowTouchMove,
        touchRatio: options.touchRatio,
        spaceBetween: options.spaceBetweenThumbs,
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
        }
    });

    function getDirection() {
        let direction = 'horizontal';
        if (options.directionThumbs === "vertical") {
            direction = window.innerWidth > options.directionBreakpoint ? 'vertical' : 'horizontal';
        }
        return direction;
    }

    return swiperThumbsImages;
}

export function initItemcardImages() {
    const wrapper = document.querySelector('.js-itemcardImages');
    if (wrapper) {
        const mainImages = wrapper.querySelector('.js-itemcardImagesMain');
        const thumbsImages = wrapper.querySelector('.js-itemcardImagesThumbs');
        let swiperThumbs = false;

        let options = getOptionsFromJsonString(wrapper.getAttribute('data-options'), {
            eff_interval: 300,
            directionThumbs: "horizontal",
            directionBreakpoint: GLOBALS.gridBreakpoints.sm - 1,
            slidesPerViewThumbs: 5,
            spaceBetweenThumbs: 20
        });

        if (wrapper.classList.contains('thumbsLeft')) {
            options.directionThumbs = "vertical";
        }

        if (mainImages) {
            wrapper.classList.add("is-loading");
            if (thumbsImages) {
                swiperThumbs = buildItemcardThumbsSwiper(thumbsImages, options, mainImages);
            } else {
                console.error('Thumbs Images not found');
            }
            buildItemcardMainSwiper(mainImages, options, swiperThumbs, function () {
                setTimeout(function () {
                    updateYTPlaceholders(wrapper);

                    installClickBlockerForYT();

                    wrapper.classList.remove("is-loading");
                    wrapper.classList.add("initialized");
                }, 200);
            });
        } else {
            console.error('Main Images not found');
        }
    }
}

